<script>

  import { External, M } from '../../external';
  import { onDestroy, onMount } from 'svelte';

  export let amount, futureAmount, currency, settings, inCheckout;

  let listener = null;

  export const onAmountChange = () => {
  };

  export const getPaymentDetails = async (billingInfo) => {
    return new Promise(async (resolve, reject) => {
      listener = (event) => {
        if (event.key === 'payfast-notification') {
          cleanupListener();

          if ((event.newValue || '').startsWith('yes')) {
            resolve({
              cardType: 'Payfast',
              nonce: 'payfast'
            });
          } else {
            reject('Canceled by user');
          }
        }
      };

      window.addEventListener('storage', listener);

      let left = screen.width / 2 - 450;
      let top = screen.height / 2 - 350;
      let windowOptions = `location=yes,scrollbars=yes,status=yes,width=900,height=700,left=${left},top=${top}`;
      let win = window.open(`${location.protocol}//${location.host}/_service/payfast/setup?a=${amount}`, '_blank', windowOptions);
      win.focus();
    });
  };

  let setup = async () => {
  };

  let cleanupListener = () => {
    if (listener) {
      try {
        window.removeEventListener('storage', listener);
        listener = null;
      } catch (e) {
      }
    }
  };

  let teardown = () => {
    cleanupListener();
  };

  onMount(() => {
  });

  onDestroy(teardown);
</script>

<div class="payment-info">
  <div class="col20 f-left card-form">
    <div class="col20 f-left">
      <span class="mt-15 mb-15" style="color: #666; line-height:1.4; font-size: 14px">
        {inCheckout ? 'You will be asked to enter your card details after clicking Subscribe.' : 'Use the button below to connect your new card.'}
      </span>
    </div>
  </div>
</div>
